import type { PILOT_COMPONENTS_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/pilot-components-table/pilot-components-table.fr.ts";

export const PILOT_COMPONENTS_TABLE_ENGLISH_LOCALE = {
  globalSearchPlaceholder: "Search a value...",
  headers: {
    brand: "Brand",
    description: "Description",
    note: "Note",
    serial: "Serial number",
  },
  empty: "No component found...",
} satisfies typeof PILOT_COMPONENTS_TABLE_FRENCH_LOCALE;
